module.exports = __webpack_public_path__ + "static/media/right-arrow.22275133.svg";